import { MouseEvent, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'

import classNames from 'classnames'
import { useVersion } from 'hooks'
import { ReactComponent as ArrowIcon } from 'assets/svg/arrow.svg'

import styles from './DropDown.module.scss'

const DropDown = () => {
  const location = useLocation()
  const { version, isEventPage } = useVersion()

  const [isOpen, setIsOpen] = useState(false)

  const handleClick = (e: MouseEvent<HTMLAnchorElement>, to: string) => {
    if (location.pathname === to) {
      e.preventDefault()
    }
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.head} onClick={() => setIsOpen(!isOpen)}>
        <p>Past events</p>
        <ArrowIcon />
      </div>
      <div className={classNames(styles.body, { [styles.body_active]: isOpen })}>
        <NavLink
          to='/events/2025'
          rel='noopener noreferrer'
          target='_blank'
          className={() =>
            classNames(styles.body__item, { [styles.body__item_active]: isEventPage && version === 2025 })
          }
          onClick={e => handleClick(e, '/events/2025')}
        >
          2025
        </NavLink>

        <NavLink
          to='/events/2024'
          rel='noopener noreferrer'
          target='_blank'
          className={() =>
            classNames(styles.body__item, { [styles.body__item_active]: isEventPage && version === 2024 })
          }
          onClick={e => handleClick(e, '/events/2024')}
        >
          2024
        </NavLink>
      </div>
    </div>
  )
}

export default DropDown
